import React, { PropTypes } from 'react';
import truncate from 'lodash/truncate';
import StarRating from 'common/components/star_rating';
import { getParticipantEmail } from 'focus_groups/utils';
import moment from 'moment';

const ResultCommentTile = ({ participant_email, participant_name, score, created_at, comment }) => {
  const email = getParticipantEmail(participant_email);
  const names = participant_name ? participant_name.split(' ') : email.split(' ');
  const initials = names.reduce((mem, name) => (`${mem}${name[0]}`), '');

  return (
    <div className="focus-group-comment">
      <div className="row">
        <div className="columns small-16">
          <div className="comment-date">{moment(created_at).fromNow()}</div>
        </div>
        <div className="columns small-4 medium-3">
          <div className="avatar avatar-md avatar-round avatar-text avatar-shadow avatar-inline">
            {initials}
          </div>
        </div>
        <div className="columns small-12 medium-13 large-10">
          <div className="comment-wrapper">
            <div className="comment-name">
              {truncate(participant_name || email, { length: 25 })}
            </div>
            <StarRating readonly={true} initialRate={score}/>
            <div>{comment}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

ResultCommentTile.propTypes = {
  participant_email: PropTypes.string.isRequired,
  participant_name: PropTypes.string,
  score: PropTypes.number.isRequired,
  created_at: PropTypes.string,
  comment: PropTypes.string,
};

export default ResultCommentTile;



// WEBPACK FOOTER //
// ./focus_groups/components/result_comment_tile.jsx